// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-wavies__tabs__item{min-width:210px;max-width:225px}.w-wavies__tabs__item__content{padding-left:10px;text-align:left}.w-wavies__item__content__play{text-transform:none}.w-wavies .v-tabs__container{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
